import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { COOKIES } from '../../_shared/constants/cookies';
import SearchModal from '../../components/SearchModal';
import { SEARCH_IN } from '../../_shared/constants/search';
import navigateBack from '../../_shared/helpers/navigateBack';

const Search = () => {
  const history = useHistory();
  const { context } = useParams();
  const searchString = window.location.search;
  const params = new URLSearchParams(searchString);
  const query = params && params.get('q');

  return (
    <SearchModal
      testId="searchPage"
      isModalOpen
      searchInputString={query || ''}
      pageNumber={(params && Number(params.get('page'))) || 1}
      preSelectedTradeState={(params && params.get('tradeState')) || undefined}
      searchSource={context || SEARCH_IN.BUY}
      closeHandler={() => navigateBack(COOKIES.GO_BACK_FROM_SEARCH, history)}
      source="search"
    />
  );
};

export default Search;
